import PropTypes from 'prop-types';
import { useEffect } from 'react';

// project imports
import useConfig from 'hooks/useConfig';
import { useTranslation } from 'react-i18next';

// ==============================|| LOCALIZATION ||============================== //

export default function Locales({ children }) {
  const { i18n } = useConfig();
  const { i18n: i18next } = useTranslation();

  useEffect(() => {
    if (i18next.language !== i18n) {
      i18next.changeLanguage(i18n);
    }
  }, [i18n, i18next]);

  return <>{children}</>;
}

Locales.propTypes = { children: PropTypes.node };
